export default "__VITE_ASSET__Bse6hKVE__"